import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronBottom: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconChevronBottom"><Path fillRule="evenodd" clipRule="evenodd" d="M3.46967 8.46967C3.76256 8.17678 4.23744 8.17678 4.53033 8.46967L11.1161 15.0555C11.6043 15.5436 12.3957 15.5436 12.8839 15.0555L19.4697 8.46967C19.7626 8.17678 20.2374 8.17678 20.5303 8.46967C20.8232 8.76256 20.8232 9.23744 20.5303 9.53033L13.9446 16.1161C12.8706 17.1901 11.1294 17.1901 10.0555 16.1161L3.46967 9.53033C3.17678 9.23744 3.17678 8.76256 3.46967 8.46967Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronBottom;
